import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";
import { HTMLInputAdapter, TextLineStateless } from "@com.mgmtp.a12.widgets/widgets-core";
import { Button } from "@com.mgmtp.a12.widgets/widgets-core/lib/button/main/button.view";
import { ButtonGroup } from "@com.mgmtp.a12.widgets/widgets-core/lib/button-group/main/button-group.view";
import { ModalNotification } from "@com.mgmtp.a12.widgets/widgets-core/lib/modal-notification/main/modal-notification.view";

import { getViewHtmlId } from "../../focusHandling/sagas";

import { SUBMIT_SELECT_OPENREGISTER_RECORD } from "../actions";
import { OpenregisterSelectRecordModalDescriptor } from "../descriptors";

const TextLine = HTMLInputAdapter(TextLineStateless);

export const OpenregisterSelectRecordModal: View.ViewComponent = function OpenregisterSelectRecordModal(props) {
	const { activityId } = props;

	const dispatch = useDispatch();
	const descriptor = useSelector(ActivitySelectors.activityPropById(activityId, it => it.descriptor));
	const [recordId, setRecordId] = React.useState("");

	const onCancel = React.useCallback(() => {
		dispatch(ActivityActions.cancel({ activityId }));
	}, [dispatch, activityId]);

	const onConfirm = React.useCallback(() => {
		if (recordId.trim()) {
			dispatch(SUBMIT_SELECT_OPENREGISTER_RECORD({ activityId, recordId: recordId.trim() }));
		}
	}, [dispatch, activityId, recordId]);

	const isValidDescriptor = OpenregisterSelectRecordModalDescriptor.isInstance(descriptor);

	return (
		<ModalNotification
			id={getViewHtmlId(activityId)}
			onClose={onCancel}
			title="Datensatz-ID manuell setzen"
			footer={
				<ButtonGroup alignment="right">
					<Button label="Abbrechen" secondary onClick={onCancel} />
					<Button
						label="Übernehmen"
						primary
						disabled={!recordId.trim() || !isValidDescriptor}
						onClick={onConfirm}
					/>
				</ButtonGroup>
			}
		>
			<TextLine
				id={getViewHtmlId(activityId) + "record-id-input"}
				label="Datensatz-ID"
				value={recordId}
				onValueChange={setRecordId}
			/>
		</ModalNotification>
	);
};
